import { snakeCase, mapKeys, Dictionary } from 'lodash';
interface NumberCollection {
  [k: string]: number;
}

/**
 * Returns the key of the highest valued value.
 *
 * e.g.
 *
 * {"a": 10, "b": "20"} => "b"
 */
export function getHighestValueKey(obj: NumberCollection): string {
  let highestKey = '';
  let highestValue = Number.NEGATIVE_INFINITY;
  for (let k in obj) {
    if (obj[k] > highestValue) {
      highestValue = obj[k];
      highestKey = k;
    }
  }
  return highestKey;
}

export const toSnakeCase = (obj: Dictionary<string>) => {
  return mapKeys(obj, (value, key) => snakeCase(key));
};



// WEBPACK FOOTER //
// ./app/utils/collections.ts